<template>
  <div class="doc-list">
    <div class="item" v-for="item in list" :key="item.id">
      <div :class="[
            'img',
            {
              selectable: item.status == '已发布'
            },
            { select: copyTaskId == item.id }
          ]" :style="{
  background: `url('${item.fileUrlImg}') no-repeat center center /100% auto`
}" @click="handleSelectTask(item)">
      </div>
      <div class="info-con">
        <div style="cursor: pointer;width: 240px;overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
" v-if="item.show" @click="getName(item)">{{ item.title }}</div>
        <el-input style="cursor: pointer" v-else ref="input" v-model="fileName"  @blur="onBlur(item)"></el-input>
        <div class="bott">
          <p>编辑于&nbsp;{{ item.updateTime | dateFormatter }}</p>
          <div class="edit-con">
            <template>
              <xdoc-view :src="item.fileUrl" ref="dia"></xdoc-view>
<!--              <i @click="goSeeImg(item.fileUrl)" class="el-icon-view"></i>-->
              <template v-if="downloading">
                <i class="el-icon-loading"></i>
              </template>
              <template v-else>
                <a :href="item.fileUrl" download style="color: rgba(0, 0, 0, 0.45);">
                  <i class="el-icon-download"></i>
                </a>
              </template>
            </template>
          </div>
        </div>
      </div>
      <div>
        <div class="img1"></div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import XdocView from '@/components/pc/XdocView'
export default {
  name: "authority",
  props:{
    list: {
      type: Array,
      default: () => []
    }
  },
  components:{
    XdocView
  },
  data(){
    return{
      downloading: false,
      packUp: false,
      imageDialogUrl:'',
      show: false,
      fileName:''
    }
  },
  methods:{
    init(){
      this.packUp = true
    },
    goSeeImg(fileUrl){
      console.log(123)
      window.open(`https://view.xdocin.com/view?src=${fileUrl}`)
      // console.log(this.$refs.dia)
      // this.$refs.dia[index].init()
    },
    getName(item){
      item.show = false
      this.fileName = item.title
    },
    onBlur(item){
      item.show = true
      const data = {
        id: item.id,
        name: this.fileName
      }
      this.$request.authorityName(data).then( res => {
        this.$message.success('修改成功')
        item.title = this.fileName
      })
    }
  },
  filters: {
    dateFormatter(val) {
      return moment(val).format('YYYY-MM-DD HH:mm')
    }
  },
}
</script>

<style scoped lang="less">
.doc-list {
  margin-top: 4px;
  display: flex;
  flex-wrap: wrap;
  padding-top: 20px;

  &>.item {
    flex: 0 0 240px;
    height: 220px;
    margin-right: 54px;
    margin-bottom: 20px;

    &:nth-child(3n) {
      margin-right: 0;
    }

    &>.img {
      width: 240px;
      height: 136px;
      border-radius: 12px;
      position: relative;
      box-sizing: border-box;
      overflow: hidden;
      border: 1px solid #eee;

      &.add {
        background: url('~@/assets/imgs/add-circle-fill@2x.png') no-repeat center center / 56px auto;
        background-color: #f0f0f0;
      }

      &>.type {
        width: 80px;
        height: 80px;
        transform: translate(-40px, -40px) rotate(-45deg);

        &.s1 {
          font-size: 12px;
          line-height: 20px;
          color: #fff;

          &::after {
            content: '已发布';
            display: block;
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 20px;
            background-color: #52c41a;
            text-align: center;
            box-sizing: border-box;
          }
        }

        &.s2 {
          font-size: 12px;
          line-height: 20px;
          color: #fff;

          &::after {
            content: '未发布';
            display: block;
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 20px;
            background-color: #d9d9d9;
            text-align: center;
            box-sizing: border-box;
          }
        }

        &.s3 {
          font-size: 12px;
          line-height: 20px;
          color: #fff;

          &::after {
            content: '线下文档';
            display: block;
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 20px;
            background-color: #52c41a;
            text-align: center;
            box-sizing: border-box;
          }
        }
      }
    }

    &>.imgurl {
      width: 240px;
      height: 136px;
    }

    &>.info-con {
      padding-top: 12px;

      &>div {
        color: rgba(0, 0, 0, 0.85);
      }

      &>p {
        padding-top: 5px;
        font-size: 12px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.45);
        margin: 0;
      }
    }
  }
}
.bott {
  display: flex;
  margin-top: 6px;
  height: 24px;
  align-items: center;
  justify-content: space-between;
  &>p {
    padding-top: 5px;
    font-size: 12px;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.45);
    margin: 0;
  }
  &>.info {
    flex: 1;
    color: rgba(0, 0, 0, 0.45);

    &.publish {
      color: #52c41a;
    }
  }

  &>.edit-con {
    flex: 0 0 auto;

    &>i {
      font-size: 16px;
      color: rgba(0, 0, 0, 0.45);
      cursor: pointer;
      margin: 0 5px;

      &:hover {
        color: #e60027;
      }

      &.el-icon-loading {
        cursor: default;
        color: rgba(0, 0, 0, 0.45);
      }
    }

    &>.eye {
      cursor: pointer;
      display: inline-block;
      background: url('~@/assets/imgs/icon_see_default@2x.png') no-repeat center center / 24px auto;
      height: 24px;
      width: 24px;
    }

    &>.download {
      cursor: pointer;
      display: inline-block;
      background: url('~@/assets/imgs/icon_download_default@2x.png') no-repeat center center / 24px auto;
      height: 24px;
      width: 24px;
    }

    &>.edit {
      display: inline-block;
      background: url('~@/assets/imgs/icon_edit_default@2x.png') no-repeat center center / 24px auto;
      height: 24px;
      width: 24px;
      cursor: pointer;
    }
  }
}
</style>
